import React, { createContext, useContext, useState, ReactNode } from "react";

interface ChatSidebarContextType {
  isOpen: boolean;
  width: number;
  setIsOpen: (open: boolean) => void;
  setWidth: (width: number) => void;
  toggleSidebar: () => void;
}

const ChatSidebarContext = createContext<ChatSidebarContextType | undefined>(
  undefined
);

interface ChatSidebarProviderProps {
  children: ReactNode;
}

export const ChatSidebarProvider: React.FC<ChatSidebarProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [width, setWidth] = useState(400);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const value = {
    isOpen,
    width,
    setIsOpen,
    setWidth,
    toggleSidebar,
  };

  return (
    <ChatSidebarContext.Provider value={value}>
      {children}
    </ChatSidebarContext.Provider>
  );
};

export const useChatSidebar = () => {
  const context = useContext(ChatSidebarContext);
  if (context === undefined) {
    throw new Error("useChatSidebar must be used within a ChatSidebarProvider");
  }
  return context;
};
